import { tokenizeCard } from './adyen_tokenization';
import APIRequest from '../components/api_request';
import UrlHelpers from '../components/shared/url_helpers';
import { browserInfo } from './browser_info';
import { ITokenizedCreditCardData as TokenizedFields } from './card_data';

interface BillingAddressInput {
  name: string;
  streetAddress: string;
  extendedAddress: string;
  locality: string;
  region: string;
  postalCode: string;
  countryCode: string;
}

interface CreditCardInput {
  id?: string | number;
  cardholderName: string;
  expirationMonth?: string;
  expirationYear?: string;
  cardNumber?: string;
  cvv?: string;
}

function mapLegacyTokenizedCard(creditCardInput: CreditCardInput) {
  return {
    adyen_token: tokenizeCard({
      number: creditCardInput.cardNumber,
      cvc: creditCardInput.cvv,
      holderName: creditCardInput.cardholderName,
      expiryMonth: creditCardInput.expirationMonth,
      expiryYear: creditCardInput.expirationYear,
    }),
  };
}

function mapCreditCardCreateParams(tokenizedFields: TokenizedFields) {
  return { adyen_token: tokenizedFields };
}

function mapCreditCardUpdateParams(creditCardInput: CreditCardInput) {
  return mapLegacyTokenizedCard(creditCardInput);
}

export function shouldUseAdyenCheckoutAPIForUpdates() {
  return false; // This function can be removed once removed from Core.
}

export function saveCreditCard(
  creditCardInput: CreditCardInput,
  tokenizedFields: TokenizedFields,
  billingAddressInput: BillingAddressInput,
) {
  const commonParams = {
    browser_info: browserInfo(),
    channel: 'Web',
    billing_address: {
      name: billingAddressInput.name,
      street_address: billingAddressInput.streetAddress,
      extended_address: billingAddressInput.extendedAddress,
      locality: billingAddressInput.locality,
      region: billingAddressInput.region,
      postal_code: billingAddressInput.postalCode,
      country_code: billingAddressInput.countryCode,
    },
    cardholder_name: creditCardInput.cardholderName,
  };

  const isCreate = !creditCardInput.id;
  if (isCreate) {
    return APIRequest.V3.post(
      UrlHelpers.myCreditCardsCreatePath(),
      {
        ...commonParams,
        ...mapCreditCardCreateParams(tokenizedFields),
      },
    );
  }

  return APIRequest.V3.put(
    UrlHelpers.myCreditCardPath(creditCardInput.id),
    {
      ...commonParams,
      ...mapCreditCardUpdateParams(creditCardInput),
    },
  );
}

export default saveCreditCard;
